import React from 'react';
import { COMPANY } from '../../mock';

export default function WhatsAppButton() {
  const href = `https://wa.me/${COMPANY.whatsapp}?text=${encodeURIComponent(
    'Bună ziua! Aș dori mai multe informații despre schele.'
  )}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="Scrie-ne pe WhatsApp"
      style={{ bottom: 'calc(env(safe-area-inset-bottom, 0px) + 5.5rem)' }}
      className="fixed right-5 sm:right-6 sm:!bottom-6 z-40 flex items-center gap-2 rounded-full bg-[#25D366] pl-3.5 pr-4 py-3 shadow-lg hover:shadow-[0_12px_30px_-8px_rgba(37,211,102,0.6)] transition-all duration-300 hover:-translate-y-1"
    >
      <svg width="22" height="22" viewBox="0 0 24 24" fill="#0a0b0d" aria-hidden="true">
        <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38c1.45.79 3.08 1.21 4.79 1.21h.01c5.46 0 9.91-4.45 9.91-9.91S17.5 2 12.04 2zm5.8 14.02c-.24.68-1.4 1.3-1.94 1.38-.5.07-1.13.1-1.82-.11-.42-.13-.96-.31-1.65-.61-2.9-1.25-4.79-4.17-4.94-4.36-.14-.19-1.18-1.57-1.18-2.99 0-1.42.75-2.12 1.01-2.41.26-.29.57-.36.76-.36.19 0 .38 0 .55.01.18.01.41-.07.64.49.24.57.81 1.99.88 2.13.07.14.12.31.02.5-.09.19-.14.31-.28.48-.14.17-.29.37-.42.5-.14.14-.28.29-.12.57.16.28.72 1.19 1.55 1.93 1.06.95 1.96 1.24 2.24 1.38.28.14.44.12.6-.07.17-.19.69-.81.87-1.09.18-.28.36-.23.61-.14.25.09 1.6.75 1.87.89.28.14.46.21.53.32.07.11.07.64-.17 1.32z"/>
      </svg>
      <span className="text-[14px] font-semibold text-[#0a0b0d]">Scrie-ne</span>
    </a>
  );
}
